import * as actionsTypes from './actionsTypes';
import axios from 'axios';
import { DB_KEY } from '../../API/API';
import * as utils from '../../utils/utils';

export const authStart = () => {
  return {
    type: actionsTypes.AUTH_START
  };
};

export const authSuccess = (token, userId, email) => {
  return {
    type: actionsTypes.AUTH_SUCCESS,
    token: token,
    userId: userId,
    userName: utils.getUserFromEmail(email)
  };
};

export const authFail = error => {
  return {
    type: actionsTypes.AUTH_FAIL,
    error: error
  };
};

export const logOut = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('expirationDate');
  localStorage.removeItem('userId');
  localStorage.removeItem('userName');
  localStorage.removeItem('email');
  return {
    type: actionsTypes.AUTH_LOGOUT
  };
};

export const checkTimeOut = time => {
  return dispatch => {
    setTimeout(() => {
      dispatch(logOut());
    }, time * 1000);
  };
};

export const userAuthentication = (email, password, isSignup) => {
  return dispatch => {
    dispatch(authStart());
    axios
      .post(
        utils.checkoutUserStatus(isSignup, DB_KEY),
        utils.getAuthData(email, password)
      )
      .then(response => {
        const {
          data: { idToken, localId, expiresIn }
        } = response;
        localStorage.setItem('token', idToken);
        localStorage.setItem('userId', localId);
        localStorage.setItem(
          'expirationDate',
          utils.getexpirationTime(expiresIn)
        );
        localStorage.setItem('userName', utils.getUserFromEmail(email));
        localStorage.setItem('email', email);
        dispatch(authSuccess(idToken, localId, email));
        dispatch(checkTimeOut(expiresIn));
      })
      .catch(err => {
        const {
          response: {
            data: {
              error: { message }
            }
          }
        } = err;
        dispatch(authFail(message));
      });
  };
};

export const authCheckState = () => {
  return dispatch => {
    const token = localStorage.getItem('token');
    if (!token) {
      dispatch(logOut());
    } else {
      const expirationDate = new Date(localStorage.getItem('expirationDate'));
      if (expirationDate <= new Date()) {
        dispatch(logOut());
      } else {
        const userId = localStorage.getItem('userId');
        const email = localStorage.getItem('email');
        dispatch(authSuccess(token, userId, email));
        dispatch(
          checkTimeOut((expirationDate.getTime() - new Date().getTime()) / 1000)
        );
      }
    }
  };
};
